__turbopack_context__.v({
  "active": "GlitchFx-module-scss-module__xe0aiW__active",
  "blueShift": "GlitchFx-module-scss-module__xe0aiW__blueShift",
  "fast": "GlitchFx-module-scss-module__xe0aiW__fast",
  "glitch-blue": "GlitchFx-module-scss-module__xe0aiW__glitch-blue",
  "glitch-red": "GlitchFx-module-scss-module__xe0aiW__glitch-red",
  "glitchFx": "GlitchFx-module-scss-module__xe0aiW__glitchFx",
  "glitchLayer": "GlitchFx-module-scss-module__xe0aiW__glitchLayer",
  "medium": "GlitchFx-module-scss-module__xe0aiW__medium",
  "redShift": "GlitchFx-module-scss-module__xe0aiW__redShift",
  "slow": "GlitchFx-module-scss-module__xe0aiW__slow",
});
